import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersBehind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconLayersBehind"><Path d="M4.75 3C4.33579 3 4 3.33579 4 3.75C4 4.16421 4.33579 4.5 4.75 4.5H19.25C19.6642 4.5 20 4.16421 20 3.75C20 3.33579 19.6642 3 19.25 3H4.75Z" fill="currentColor"/><Path d="M2.75 6C2.33579 6 2 6.33579 2 6.75V19.25C2 19.6642 2.33579 20 2.75 20H21.25C21.6642 20 22 19.6642 22 19.25V6.75C22 6.33579 21.6642 6 21.25 6H2.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayersBehind;
